import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { SignalRDynamicReportResponse } from '@/main/models/common/signalRReceiveUpdatesResponse';

interface HubItemDynamicReportProps {
  data: SignalRDynamicReportResponse[];
}

const HubItemDynamicReport = ({ data }: HubItemDynamicReportProps) => {
  useEffect(() => {
    if (data && data.length > 0) {
      const lastUpdate = data[data.length - 1];

      if (lastUpdate.isSuccess && lastUpdate.message) {
        toast.success(lastUpdate.message);
      } else if (!lastUpdate.isSuccess && lastUpdate.message) {
        toast.error(lastUpdate.message);
      }
    }
  }, [data]);

  return null;
};

export default HubItemDynamicReport;